import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const reviewService = {
  studentReviews: (p: { page?: number; limit?: number; search?: string } = {}, isSchoolAdmin = false) => {
    const ep = isSchoolAdmin ? endpoints.reviewSchoolAdmin.getStudentReview : endpoints.review.getStudentReview
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${ep}?${q(params)}`).then(r => r.data)
  },
  trainerReviews: (p: { page?: number; limit?: number; search?: string } = {}, isSchoolAdmin = false) => {
    const ep = isSchoolAdmin ? endpoints.reviewSchoolAdmin.getTrainerReview : endpoints.review.getTrainerReview
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${ep}?${q(params)}`).then(r => r.data)
  },
  delete:   (id: number) => restClient.delete(`${endpoints.review.deleteReview}id=${id}`).then(r => r.data),
  update:   (data: Record<string, unknown>) => restClient.post(endpoints.review.updateReview, data).then(r => r.data),
}
